<template>
  <section class="section"></section>

  <div class="dg-container shape-container d-flex align-items-center">
    <div class="col px-0">
      <div class="row justify-content-center align-items-center">
        <div class="col-lg-5 order-md-3 hidden-sm-and-down">
          <img src="img/homepage/protection-cover.png" class="img-fluid floating"/>
        </div>
        <div class="col-lg-1 order-md-2 hidden-sm-and-down"></div>
        <div class="col-lg-6 order-md-1">
          <h3 class="hp-title2 pb-4">Protection Products</h3>
          <p class="hp-desc">Blockchain is miserable, where risk and reward are widely extended. DEGIS is the shield to protect you. With innovative insurance products, DEGIS is attractive to both
            on-chain and off-chain buyers. Buyers can hedge their risk through insurance products while providers can earn attractive yield.</p>
          <div class="btn-wrapper d-flex pt-4 justify-content-between" style="padding-right: 15%">
            <a href="/#/protection">
              <base-button>launch product</base-button>
            </a>
            <a href="https://docs.degis.io/">
              <base-button>Read More</base-button>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import BaseButton from "../../components/BaseButton";
export default {
  name: "protectioncover",
  // components: {BaseButton},
};
</script>

<style scoped>

</style>
